/* @flow */
const prefix = str => `station/constellation/${str}`;

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const FETCH_EXPLOSION = prefix('FETCH_EXPLOSION');
export const FETCH_EXPLOSION_SUCCESS = prefix('FETCH_EXPLOSION_SUCCESS');
export const FETCH_EXPLOSION_FAILURE = prefix('FETCH_EXPLOSION_FAILURE');

export const CLEAR_EXPLOSION = prefix('CLEAR_EXPLOSION');

export const CLEAR = prefix('CLEAR');

export const TOGGLE_NODE = prefix('TOGGLE_NODE');
export const NODE_CLICKED = prefix('NODE_CLICKED');
export const REPLACE_SELECTION = prefix('REPLACE_SELECTION');
export const DELETE_NODES = prefix('DELETE_NODES');
export const DELETE_NODES_SUCCESS = prefix('DELETE_NODES_SUCCESS');

export const SET_FILTERS = prefix('SET_FILTERS');
export const SET_FILTERS_SUCCESS = prefix('SET_FILTERS_SUCCESS');
export const SET_OPTIONS = prefix('SET_OPTIONS');
export const SET_HOVERED_NODE_ID = prefix('SET_HOVERED_NODE_ID');
export const SET_ROOT_NODE_ID = prefix('SET_ROOT_NODE_ID');

export const SET_MODAL_OPTIONS = prefix('SET_MODAL_OPTIONS');

export const UPDATE_TIME_RANGE = prefix('UPDATE_TIME_RANGE');
export const CACHE_GRAPH_SIMULATION = prefix('CACHE_GRAPH_SIMULATION');
export const CACHE_GRAPH_SIMULATION_SUCCESS = prefix('CACHE_GRAPH_SIMULATION_SUCCESS');
export const INVALIDATE_GRAPH_CACHE = prefix('INVALIDATE_GRAPH_CACHE');

export const UNDO = prefix('UNDO');
export const REDO = prefix('REDO');
export const RESET = prefix('RESET');
export const UNDO_SUCCESS = prefix('UNDO_SUCCESS');
export const REDO_SUCCESS = prefix('REDO_SUCCESS');
export const RESET_SUCCESS = prefix('RESET_SUCCESS');

export const CLOSE_TIME_RANGE_EXPLANATION = prefix('CLOSE_TIME_RANGE_EXPLANATION');
export const EXPORT_INDICATORS = prefix('EXPORT_INDICATORS');

export const SAVE_NOTE = prefix('SAVE_NOTE');
export const SAVE_NOTE_SUCCESS = prefix('SAVE_NOTE_SUCCESS');
export const SAVE_NOTE_FAILURE = prefix('SAVE_NOTE_FAILURE');

export const UPDATE_NOTE = prefix('UPDATE_NOTE');
export const UPDATE_NOTE_SUCCESS = prefix('UPDATE_NOTE_SUCCESS');
export const UPDATE_NOTE_FAILURE = prefix('UPDATE_NOTE_FAILURE');

export const DELETE_NOTE = prefix('DELETE_NOTE');
export const DELETE_NOTE_SUCCESS = prefix('DELETE_NOTE_SUCCESS');
export const DELETE_NOTE_FAILURE = prefix('DELETE_NOTE_FAILURE');

export const PROCESS_ANNOTATIONS_SUCCESS = prefix('PROCESS_ANNOTATIONS_SUCCESS');
export const PROCESS_ANNOTATIONS_FAILURE = prefix('PROCESS_ANNOTATIONS_FAILURE');

export const SET_ACTIVE_NOTE = prefix('SET_ACTIVE_NOTE');

export const HIGHLIGHT_NODE = prefix('HIGHLIGHT_NODE');
export const RESET_HIGHLIGHT_NODE = prefix('RESET_HIGHLIGHT_NODE');

export const GO_TO_BREADCRUMB = prefix('GO_TO_BREADCRUMB');
export const ADD_BREADCRUMB = prefix('ADD_BREADCRUMB');
export const RESET_BREADCRUMBS = prefix('RESET_BREADCRUMBS');



// WEBPACK FOOTER //
// ./src/app/modules/constellation/action-types.js